import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const LandingPage = lazy(() =>
  import('./pages/landing-page').then((m) => ({ default: m.LandingPage })),
);

// Lazy-loaded landing routes. The root tree composes these under `<LandingLayout>`
// (see routes/index.tsx).

export const landingRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <Suspense fallback={null}>
        <LandingPage />
      </Suspense>
    ),
  },
];
